"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  properties: {
    collapsed: {
      type: 'boolean'
    }
  }
};
exports.default = _default;